/**
 * 表示対象（配送形態・区間種別）を API のクエリパラメータへ落とす。
 *
 * API は除外方式で受ける（`excluded_*`）。画面が「隠している値の集合」を持っているので、
 * そのまま渡せる形にしてある。未設定の案件を残す判断はサーバー側が持つ。
 */
import { OrderAttrFilter } from './orderAttrFilter';

/**
 * Set は挿入順を持つ。並べ替えないと、同じ絞り込みでもチェックした順番で
 * クエリ文字列とキャッシュキーが変わり、取り直しが起きる
 */
const sorted = (values: ReadonlySet<string>): string[] => [...values].sort();

const params = (name: string, values: ReadonlySet<string>): string[] =>
  sorted(values).map((value) => `&${name}[]=${encodeURIComponent(value)}`);

/** リクエストパスへ足す断片。何も隠していなければ空文字 */
export const orderAttrFilterQuery = (filter: OrderAttrFilter): string => [
  ...params('excluded_delivery_methods', filter.hiddenDeliveryMethods),
  ...params('excluded_leg_stats', filter.hiddenSegmentStats),
].join('');

/**
 * キャッシュキー用の安定トークン。
 * 2 つの次元は `|` で区切る。区切らないと ['配送'] と [[], ['配送']] が同じ文字列になる
 */
export const orderAttrFilterToken = (filter: OrderAttrFilter): string =>
  `${sorted(filter.hiddenDeliveryMethods).join(',')}|${sorted(filter.hiddenSegmentStats).join(',')}`;
